import { render, staticRenderFns } from "./HsabExpenseDetailsModal.vue?vue&type=template&id=38d9957c"
import script from "./HsabExpenseDetailsModal.vue?vue&type=script&lang=ts"
export * from "./HsabExpenseDetailsModal.vue?vue&type=script&lang=ts"
import style0 from "./HsabExpenseDetailsModal.vue?vue&type=style&index=0&id=38d9957c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports